/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ServicedeskKnowledgeHubBrowseAllCategoriesType from '@jira/spa-apps__servicedesk-knowledge-hub-browse-all-categories/src/index.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyServicedeskKnowledgeHubBrowseAllCategories: LazyComponent<
	() => React.JSX.Element
> = lazyForPaint<typeof ServicedeskKnowledgeHubBrowseAllCategoriesType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-servicedesk-knowledge-hub-browse-all-categories", jiraSpaEntry: "async-servicedesk-knowledge-hub-browse-all-categories" */ '@jira/spa-apps__servicedesk-knowledge-hub-browse-all-categories/src/index.tsx'
		),
	),
);

const AsyncServicedeskKnowledgeHubBrowseAllCategories = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServicedeskKnowledgeHubBrowseAllCategories}
		pageId="spa-apps/servicedesk/knowledge-hub/browse-all-categories"
		shouldShowSpinner
	/>
);

export default AsyncServicedeskKnowledgeHubBrowseAllCategories;
